/**
 * Initials for an avatar fallback: first letters of the first and last word.
 * "Camilo Mejía" → "CM", "Mariana" → "M", "" → "?".
 */
export function initials(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    const first = words[0]![0]!;
    const last = words.length > 1 ? words[words.length - 1]![0]! : '';
    return (first + last).toUpperCase();
}
